import {makeAutoObservable} from 'mobx';
import {LineListRequest} from '../../entity/model/line-list-request';
import {RequestBody} from '../../entity/core/request-body';
import LineListRequestAgent from '../agent/line-list-request-agent';
import {LineListReportProps} from '../../entity/props/title/line-list-report-props';

export default class LineListRequestStore {
  private _currentProps: LineListReportProps | undefined = undefined;
  private readonly SHARED_DATA_KEY = 'lineListRequestSharedData';
  lineListRequestAgent: LineListRequestAgent;
  lineListRequests: LineListRequest[] = [];

  constructor(lineListRequestAgent: LineListRequestAgent) {
    makeAutoObservable(this);
    this.lineListRequestAgent = lineListRequestAgent;
  }

  get currentProps(): LineListReportProps | undefined {
    return this._currentProps;
  }

  setCurrentProps = (props: LineListReportProps | undefined): void => {
    this._currentProps = props;
    if (props) 
      this.setSharedData(props);
  }

  clearCurrentProps = (): void => {
    this._currentProps = undefined;
  }

  setSharedData = (props: LineListReportProps): void => {
    localStorage.setItem(this.SHARED_DATA_KEY, JSON.stringify(props));
  }

  getSharedData = (): LineListReportProps | undefined => {
    const data = localStorage.getItem(this.SHARED_DATA_KEY);
    if (data) 
      return JSON.parse(data);

    return undefined;
  }

  clearSharedData = (): void => {
    localStorage.removeItem(this.SHARED_DATA_KEY);
  }

  loadSharedData = (): void => {
    const sharedData = this.getSharedData();
    if (sharedData) {
      this._currentProps = sharedData;
      this.clearSharedData();
    }
  }

  createLineListRequest = async (organizationId: string, requestBody: RequestBody): Promise<LineListRequest | string> => {
    try {
      return await this.lineListRequestAgent.createLineListRequest(organizationId, requestBody);
    } catch (error: any) {
      console.error('Error occurred while creating line list request', error);
      return 'Error occurred while creating line list request !!';
    }
  }

  loadLineListRequests = async (organizationId: string, titleId: string): Promise<LineListRequest[] | string> => {
    try {
      const result = await this.lineListRequestAgent.getLineListRequests(organizationId, titleId);
      if (typeof result === 'string') {
        return result;
      }
      this.lineListRequests = result;
      return result;
    } catch (error: any) {
      console.error('Error occurred while loading line list requests', error);
      return 'Error occurred while loading line list requests !!';
    }
  }

  updateLineListRequest = async (organizationId: string, lineListRequestId: string, requestBody: RequestBody): Promise<LineListRequest | string> => {
    try {
      return await this.lineListRequestAgent.updateLineListRequest(organizationId, lineListRequestId, requestBody);
    } catch (error: any) {
      console.error('Error occurred while updating line list request', error);
      return 'Error occurred while updating line list request !!';
    }
  }
} 